import { ApiRequest } from '@zeal/zeal-lib';

const apiToken = import.meta.env.REACT_APP_STRAPI_TOKEN;

const apiURL = import.meta.env.REACT_APP_STRAPI_URL ?? '';

export type Locals = {
	id: number;
	name: string;
	code: string;
	createdAt: string;
	updatedAt: string;
	isDefault: boolean;
};

export const fetchLocales = async () => {
	const locales = await new ApiRequest(`${apiURL}/api/i18n/locales`)
		.addHeader('Accept', 'application/json')
		.addHeader('Content-Type', 'application/json')
		.addHeader('Authorization', `Bearer ${apiToken}`)
		.GET<Locals[]>({
			noAuth: true,
		});

	return locales;
};
